import React from 'react';
import {
  Button, ButtonText, HStack, Text, VStack,
} from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';

export type DashboardErrorProps = {
  onRetry: () => void;
  onResetFilters: () => void;
};

/**
 * Inline error under the filter bar with Retry and Reset filters.
 */
export function DashboardError({ onRetry, onResetFilters }: DashboardErrorProps) {
  const { t } = useTranslation();

  return (
    <VStack space="md" py="$4" testID="dashboard-error-state">
      <Text size="md" color="$statusError">{t('admin.analytics.error.message')}</Text>
      <HStack space="sm">
        <Button size="sm" action="primary" onPress={onRetry} testID="dashboard-retry">
          <ButtonText>{t('admin.analytics.retry')}</ButtonText>
        </Button>
        <Button
          size="sm"
          variant="outline"
          action="secondary"
          onPress={onResetFilters}
          testID="dashboard-reset-filters"
        >
          <ButtonText>{t('admin.analytics.resetFilters')}</ButtonText>
        </Button>
      </HStack>
    </VStack>
  );
}
